import { useCallback } from 'react';

const hexToRgb = (hex) => {
  let h = hex.replace('#', '');
  if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `${r} ${g} ${b}`;
};

const useTheme = () => {
  const applyTheme = useCallback((colors) => {
    const root = document.documentElement;
    if (colors?.primary_color) {
      root.style.setProperty('--color-primary', hexToRgb(colors.primary_color));
    } else {
      root.style.removeProperty('--color-primary');
    }

    if (colors?.secondary_color) {
      root.style.setProperty('--color-secondary', hexToRgb(colors.secondary_color));
    } else {
      root.style.removeProperty('--color-secondary');
    }

    if (colors?.opaque_color) {
      root.style.setProperty('--color-opaque', hexToRgb(colors.opaque_color));
    } else {
      root.style.removeProperty('--color-opaque');
    }
  }, []);

  return { applyTheme };
};

export default useTheme;
